<div>
  <div>
    <div>
      <ppt-actions-toolbar
        [reportData]="reportRecordsData"
        [currentView]="currentView"
        [templates]="templateFieldsCatalog"
        [recordsCount]="recordsCount"
        (navRecordNum)="navRecordNum($event)"
        [requiresSelectTempElement]="true"
        [requiresRecordNavigation]="false"
        [isUKFeaturesEnabled]="isUKFeaturesEnabled"
        (templateAndViewChange)="onTemplateSelectedLater($event)"
      ></ppt-actions-toolbar>
    </div>
  </div>
  <rep-dynamic-contacts
    [contactGroups]="contactGroups"
    [currentView]="currentView"
    [reportId]="reportData?.reportId"
  ></rep-dynamic-contacts>
  <div>
    <ppt-actions-toolbar
      [reportData]="reportRecordsData"
      [currentView]="currentView"
      [templates]="templateFieldsCatalog"
      [recordsCount]="recordsCount"
      (navRecordNum)="navRecordNum($event)"
      [requiresSelectTempElement]="false"
      [requiresRecordNavigation]="true"
      [isUKFeaturesEnabled]="isUKFeaturesEnabled"
      (templateChange)="onTemplateSelected($event)"
    ></ppt-actions-toolbar>
  </div>
  <rep-presentation-dynamic-view-body
    [reportData]="reportRecordsData"
    [recordNumber]="recordNumber"
    [headerGroups]="headerGroups"
    [footerGroups]="footerGroups"
    [bodyGroups]="bodyGroups"
    [imageGroups]="imageGroups"
    [currentView]="currentView"
    [reportLocale]="reportLocale"
    (removeRecord)="removeRecord.emit($event)"
    (reportReordered)="reportReordered.emit($event)"
    [templateProjectionMap]="templateProjectionMap"
  ></rep-presentation-dynamic-view-body>
</div>
